export default {"src":"/_next/static/media/background_tablet.7d57786d.svg","height":316,"width":834,"blurWidth":0,"blurHeight":0};